export default function isLastIdValid(lastId) {
    return typeof lastId === 'number';
}
